type ClipboardWriter = Pick<Clipboard, 'writeText'>;

export async function writeClipboardText(
  value: string,
  clipboard: ClipboardWriter | undefined = globalThis.navigator?.clipboard
): Promise<boolean> {
  if (!clipboard?.writeText) {
    return false;
  }

  try {
    await clipboard.writeText(value);
    return true;
  } catch {
    return false;
  }
}
